import IN_YOUR_BAG from './InYourBag.constants';

const initialState = {
  inYourBagItems: [],
  totalItems: 0,
  totalPrice: 0,
  totalSavings: 0,
};

const InYourBagReducer = (state = initialState, action) => {
  switch (action.type) {
    case IN_YOUR_BAG.SET_IN_YOUR_BAG_ITEMS:
      return {
        ...state,
        inYourBagItems: action?.payload?.iybWithLoyaltyPoints,
        totalItems: action?.payload?.totalItems,
        totalPrice: action?.payload?.totalPrice,
        totalSavings: action?.payload?.totalSavings,
      };
    default:
      return state;
  }
};

export default InYourBagReducer;
